import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { useHelp } from '../contexts/HelpContext';
import {
  AvailabilityHelpModal,
  TrainingSessionsHelpModal,
  PlannerHelpModal,
  AutoplannerHelpModal,
  TrainingGroupsHelpModal,
  CrewsHelpModal,
} from './help/HelpModals';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const isPlanningPage = location.pathname === '/planner';
  const { activeHelpModal, hideHelp } = useHelp();

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 z-[9999] flex md:hidden" role="dialog" aria-modal="true">
          <div
            className="fixed inset-0 bg-gray-600 bg-opacity-75"
            aria-hidden="true"
            onClick={() => setSidebarOpen(false)}
          ></div>
          <div className="relative flex w-full max-w-xs flex-1 flex-col bg-white">
            <Sidebar setSidebarOpen={setSidebarOpen} />
          </div>
        </div>
      )}

      {/* Desktop sidebar */}
      <div className="hidden md:flex md:flex-shrink-0">
        <div className="flex w-64 flex-col">
          <Sidebar />
        </div>
      </div>

      {/* Main content */}
      <div className="flex w-0 flex-1 flex-col overflow-hidden">
        <Navbar setSidebarOpen={setSidebarOpen} />
        {location.pathname === '/admin' ? (
          <div className="flex-1 overflow-y-auto">
            <Outlet />
          </div>
        ) : (
          <main className="relative flex-1 overflow-y-auto focus:outline-none">
            {isPlanningPage ? (
              <Outlet />
            ) : (
              <div className="py-6">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                  <Outlet />
                </div>
              </div>
            )}
          </main>
        )}
      </div>

      {/* Help Modals */}
      <AvailabilityHelpModal isOpen={activeHelpModal === 'availability'} onClose={hideHelp} />
      <TrainingSessionsHelpModal
        isOpen={activeHelpModal === 'training-sessions'}
        onClose={hideHelp}
      />
      <PlannerHelpModal isOpen={activeHelpModal === 'planner'} onClose={hideHelp} />
      <AutoplannerHelpModal isOpen={activeHelpModal === 'autoplanner'} onClose={hideHelp} />
      <TrainingGroupsHelpModal isOpen={activeHelpModal === 'training-groups'} onClose={hideHelp} />
      <CrewsHelpModal isOpen={activeHelpModal === 'crews'} onClose={hideHelp} />
    </div>
  );
};

export default Layout;
